import { render, staticRenderFns } from "./OrderFieldsList.vue?vue&type=template&id=bbd1cea4&scoped=true"
import script from "./OrderFieldsList.vue?vue&type=script&lang=js"
export * from "./OrderFieldsList.vue?vue&type=script&lang=js"
import style0 from "./OrderFieldsList.vue?vue&type=style&index=0&id=bbd1cea4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd1cea4",
  null
  
)

export default component.exports